module.exports = __webpack_public_path__ + "static/media/red_background.eeea01f9.jpg";